export function routeDataNeeds(pathname: string) {
  const managing = pathname.startsWith("/manage/");
  return {
    admin: pathname === "/admin",
    management: managing || /^\/apps\/[^/]+$/.test(pathname),
    releases: managing,
  };
}
